'use client'
import Image from 'next/image'
import { trackEvent } from '@/lib/trackEvent'
import { AIRPORT_DB } from './AirportCombobox'
import destinations from '@/data/destinations-client.json'

export default function DealsGuestWall({ hidden, _dealGradients, setShowModal, totalLocked }) {
  if (!hidden.length) return null
  const WALL_CAP = 16
  const preview = hidden.slice(0, WALL_CAP)

  return (
    <>
      <ul className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {preview.map((deal) => {
          const destData = destinations[deal.destination]
          const destCity = destData?.city_name ?? deal.destination
          const destPhoto = destData?.image_url ?? null
          const showGrad = _dealGradients.get(deal.id) ?? false
          const _oFlag = AIRPORT_DB[deal.origin]?.flag ?? ''
          const _dFlag = AIRPORT_DB[deal.destination]?.flag ?? ''
          const _gIdx = deal.destination.split('').reduce((a, c) => a + c.charCodeAt(0), 0) % 6
          const _gColors = [['#60a5fa','#4f46e5'],['#34d399','#0d9488'],['#f97316','#e11d48'],['#a78bfa','#7c3aed'],['#38bdf8','#06b6d4'],['#fbbf24','#ea580c']]
          const [_gFrom, _gTo] = _gColors[_gIdx]
          return (
            <li key={deal.id}>
              <a href="/signup" className="block group" onClick={() => trackEvent('signup_cta', { label: 'Sign up to unlock', component: 'DealsGuestWall' }, 'guest')}>
                <div className="relative bg-white rounded-2xl border border-gray-100 shadow-sm w-full overflow-hidden">
                  <div className="relative aspect-[4/3] w-full overflow-hidden">
                    {showGrad ? (
                      <div className="absolute inset-0 flex items-center justify-center gap-2" style={{background:`linear-gradient(135deg,${_gFrom},${_gTo})`}}>
                        <span className="text-5xl leading-none">{_oFlag}</span>
                        <span className="text-xl text-white/80 font-bold">→</span>
                        <span className="text-5xl leading-none">{_dFlag}</span>
                      </div>
                    ) : destPhoto
                      ? <Image src={destPhoto} alt="" fill className="object-cover" sizes="(max-width: 768px) 100vw, 50vw" />
                      : <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300" />}
                  </div>
                  <div className="p-5 space-y-3">
                    <div className="flex items-center justify-between gap-2">
                      <div className="h-4 bg-gray-100 rounded animate-pulse w-1/3" />
                      <div className="h-4 bg-gray-100 rounded animate-pulse w-1/4" />
                    </div>
                    <div className="h-8 bg-gray-100 rounded animate-pulse w-1/2" />
                    <div className="h-4 bg-gray-100 rounded animate-pulse w-3/4" />
                    <div className="flex gap-3">
                      <div className="h-4 bg-gray-100 rounded animate-pulse w-1/4" />
                      <div className="h-4 bg-gray-100 rounded animate-pulse w-1/4" />
                    </div>
                    <div className="h-5 bg-gray-100 rounded-full animate-pulse w-2/5" />
                    <div className="h-9 bg-gray-100 rounded-xl animate-pulse w-full" />
                  </div>
                  <div className="absolute inset-0 bg-white/60 backdrop-blur-[2px] flex items-center justify-center z-10 rounded-2xl">
                    <span className="inline-flex items-center gap-2 bg-white shadow-md px-5 py-2.5 rounded-full text-sm font-bold text-gray-900 group-hover:shadow-lg transition-shadow">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-gray-600" aria-hidden="true">
                        <path fillRule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clipRule="evenodd" />
                      </svg>
                      Sign up to unlock →
                    </span>
                  </div>
                </div>
              </a>
            </li>
          )
        })}
      </ul>
      <div className="mt-6 rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-700 p-8 text-center shadow-md">
        <div className="flex justify-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 text-white/90" aria-hidden="true">
            <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" />
          </svg>
        </div>
        <p className="text-2xl font-extrabold text-white tracking-tight">{(totalLocked ?? hidden.length).toLocaleString()}+ deals locked — sign up free</p>
        <p className="mt-2 text-sm text-blue-100">No card needed. Takes 30 seconds.</p>
        <ul className="mt-5 space-y-2 text-sm text-blue-100 text-left max-w-xs mx-auto">
          <li className="flex items-center gap-2"><span className="text-white font-bold">✓</span> See all prices and routes</li>
          <li className="flex items-center gap-2"><span className="text-white font-bold">✓</span> Filter by departure airport</li>
          <li className="flex items-center gap-2"><span className="text-white font-bold">✓</span> Get alerts when prices drop</li>
        </ul>
        <div className="mt-6 flex justify-center items-center gap-4 flex-wrap">
          <a href="/signup" className="rounded-xl bg-white px-8 py-3 text-base font-extrabold text-blue-700 hover:bg-blue-50 transition-colors shadow-sm" onClick={() => trackEvent('signin_cta', { label: 'Sign in', component: 'DealsGuestWall' }, 'guest')}>
            Create free account →
          </a>
          <button onClick={() => setShowModal(true)} className="text-sm font-medium text-blue-200 hover:text-white transition-colors underline underline-offset-2">
            Sign in
          </button>
        </div>
      </div>
    </>
  )
}
